import axios, { AxiosRequestConfig } from 'axios';
import { DataTable } from 'primereact/datatable';
import React, { useEffect, useState } from 'react';
import { useToast } from '../../context/ToastProvider';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { useAuth } from '../../context/AuthProvider';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';

const { REACT_APP_THINKHAUS_URL } = process.env

export const IntakeFormEmailsForm = () => {
    const [emails, setEmails] = useState([]);
    const [showAddEmail, setShowAddEmail] = useState(false);
    const [refresh, toggleRefresh] = useState(false);
    const [newEmail, setNewEmail] = useState('');
    const { showSuccess, showError } = useToast();

    let { session } = useAuth();

    const handleToastError = (error: string) => {
        showError({ detail: error, summary: 'Email operation failed', life: 9999 });
    }

    const handleToastSuccess = (success: string): void => {
        showSuccess({ detail: success });
    }

    const config: AxiosRequestConfig = {
        headers: {
            "Authorization": `Bearer ${session.access_token}`
        }
    };

    useEffect(() => {
        const fetchEmails = async () => {
            try {
                const response = await axios.get(REACT_APP_THINKHAUS_URL + 'api/intake-form-email', config)
                setEmails(response.data.responseData)
            } catch (error) {
                handleToastError(error.message);
            }
        }
        fetchEmails()
    }, [refresh])

    const handleDelete = async (id) => {
        try {
            await axios.delete(REACT_APP_THINKHAUS_URL + `api/intake-form-email/${id}`, config)
        } catch (error) {
            handleToastError(error.message);
        } finally {
            toggleRefresh(prev => !prev)
            handleToastSuccess('Email Removed Successfully')
        } 
    }

    const deleteButton = (rowData) => {
        return (<Button aria-label="Delete" icon="pi pi-trash" className="text-red-500" outlined onClick={() => handleDelete(rowData.id)} />)
    }

    const handleAddClick = () => {
        setNewEmail('');
        setShowAddEmail(true);
    }

    const handleSubmit = async (email) => {
        try {
            const response = await axios.post(REACT_APP_THINKHAUS_URL + 'api/intake-form-email', { email }, config)
            setEmails(prev => [...prev, response.data.responseData])
            handleToastSuccess('Email Successfully Added')
        } catch (error) {
            handleToastError(error.message);
        } finally {
            setShowAddEmail(false)
        }
    }

    return ( 
        <div className="w-8 col-offset-2 mt-3 surface-100">
            <div className="surface-700 text-white border-round p-4">
                <h1>Intake Form Emails</h1>
                <h3>Each email in this table will receive all intake form requests. To edit an email, delete and add again.</h3>
            </div>
            <div className="flex flex-row-reverse">
            <Button
            className="my-3"
            severity="success"
            label="Add Email"
            icon="pi pi-plus-circle"
            onClick={() => handleAddClick()} />
            </div>
            <Dialog visible={showAddEmail} onHide={() => setShowAddEmail(false)}>
                <div className='flex flex-column mt-3'>
                    <label htmlFor='email'>Email</label>
                    <InputText data-cy-email name='email' value={newEmail} onChange={(e) => setNewEmail(e.target.value)} />
                </div>
                <div className='flex flex-row mt-3'>
                    <Button severity='success' label='Submit' onClick={() => handleSubmit(newEmail)}/>
                    <Button severity='secondary' label="Cancel" onClick={() => setShowAddEmail(false)} />
                </div>
            </Dialog>
            <DataTable stripedRows header="Intake Form Emails" value={emails}>
                <Column body={(rowData) => deleteButton(rowData)} />
                <Column field='email' />
            </DataTable>
        </div>
    );
}

export default IntakeFormEmailsForm;